import Vue from "vue";

Vue.filter('number_format', function (value) {
    try {
        let thousands = ','
        let decimal = '-';
        let decimalCount = 0;

        const negativeSign = value < 0 ? "-" : "";

        let i = parseInt(value = Math.abs(Number(value) || 0).toFixed(decimalCount)).toString();
        let j = (i.length > 3) ? i.length % 3 : 0;

        return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(value - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
    }
});
